module.exports = __webpack_public_path__ + "img/40_38_029_740.794c0ef7.jpg";